import { useState } from "react";
import "./Header.scss";
import { To, useNavigate, Link } from "react-router-dom";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RoutePaths } from "src/resources/enum";
import { ReactComponent as HassantukLogo } from "src/assets/icons/hassantuk-logo-header.svg";
import { ReactComponent as LoginIcon } from "src/assets/icons/login-icon.svg";
import { ReactComponent as RegisterBMCIcon } from "src/assets/icons/register-bmc-icon.svg";
import HouseIcon from "@mui/icons-material/House";
import { Button } from "primereact/button";
import { isCivilDefenseUser } from "src/utils/helpers";
import { ReactComponent as BurgerMenu } from "src/assets/icons/burgerMenu.svg";
import MobileMenu from "../MobileMenu/MobileMenu";
import NavUserDropdown from "../NavUserDropdown/NavUserDropdown";
import VerticalDivider from "../VerticalDivider/VerticalDivider";

const Header = () => {
  const navigate = useNavigate();

  const { t } = useTranslation(["common"]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const handleClick = (path: To) => {
    setIsMobileMenuOpen(false);
    navigate(path);
  };
  const isLoggedIn = useSelector((state: any) => state.bMCProfile.token);
  return (
    <header className="m-auto" id="app-header-container">
      <div className="logos d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center ">
          <button
            className="header__menu-toggle me-3"
            onClick={toggleMobileMenu}
            aria-label="Open menu"
          >
            <BurgerMenu className="header__menu-icon" />
          </button>
          <Link to={RoutePaths.Home}> <HassantukLogo className="header__left-logo" /></Link>
         
        </div>
      </div>
      <div className="header-nav">
        <div className="header-section">
          <Link to={RoutePaths.Home} className="home-icon">
            <HouseIcon />
          </Link>
          {isLoggedIn && (
            <>
            <VerticalDivider />
            <Button
              onClick={() =>
                handleClick(
                  isCivilDefenseUser()
                    ? RoutePaths.CDDashboard
                    : RoutePaths.Dashboard
                )
              }
              className="light-primary-btn m-0"
            >
              {t("dashboard")}
            </Button>
            </>
          )}
        </div>
        <div className="header-section d-flex">
          <LanguageSelector />
          {isLoggedIn && <NavUserDropdown />}
          {!isLoggedIn && (
            <>
              <Button
                className="light-primary-btn my-0 mx-2 login-btn"
                onClick={() => handleClick(RoutePaths.Login)}
              >
                <LoginIcon />
                {t("login")}
              </Button>
              <Button
                className="primary-btn my-0 mx-2 login-btn"
                onClick={() => handleClick(RoutePaths.Register)}
              >
                <RegisterBMCIcon />
                {t("bmcRegister")}
              </Button>
            </>
          )}
        </div>
      </div>
      <MobileMenu
        isLoggedIn={isLoggedIn}
        handleClick={handleClick}
        isMobileMenuOpen={isMobileMenuOpen}
        toggleMobileMenu={toggleMobileMenu}
      />
    </header>
  );
};

export default Header;
